export default __webpack_public_path__ + "static/media/EyeCloseIcon.99eef28a.svg";